import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const items = this.element.querySelectorAll("[data-item]");
    [...items].forEach((item) => {
      if (item.dataset.defaultOpened === "1") {
        item.classList.add("active");
      }
    });
  }

  open(e) {
    e.preventDefault();
    const accordionWrapper = e.target.closest("[data-controller]");
    const items = accordionWrapper.querySelectorAll("[data-item]");
    [...items].forEach((item) => item.classList.remove("active"));
    const activeWrapper = e.target.closest("div");
    activeWrapper.classList.add("active");
  }
}
